import { createFileRoute, redirect } from "@tanstack/react-router";

/** Sammanslagen med elavtalssidan – permanent omdirigering. */
export const Route = createFileRoute("/elpriser/kvartspris")({
  beforeLoad: () => {
    throw redirect({ to: "/elavtal/kvartspris", statusCode: 301 });
  },
});
